exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".appLayoutContentWrapper--3sBj2 {\r\n\tpadding-top: 72px !important;\r\n\tmin-height: 100%;\r\n}\r\n.appLayoutContentWrapperWhite--OS_V1 {\r\n\tbackground-color: #fff;\r\n}\r\n", ""]);

// Exports
exports.locals = {
	"appLayoutContentWrapper": "appLayoutContentWrapper--3sBj2",
	"appLayoutContentWrapperWhite": "appLayoutContentWrapperWhite--OS_V1"
};